import { AccessToken } from '../../models/index';
import { StorageSet } from '../storage/index';
import { UseCase } from '../UseCase';

export class SetAccessToken implements UseCase<AccessToken, void> {
    private storageSet = new StorageSet<AccessToken>();

    execute(accessToken: AccessToken): void {
        this.storageSet.execute({ key: 'oauth.accessToken', value: accessToken });
    }
}
